import { useState } from "react";

interface IUseActionPlanSnackbarsResult {
    snackbarMessage: string;
    snackbarErrorMessage: string;
    showSuccess: (message: string) => void;
    showError: (message: string) => void;
    closeSuccess: () => void;
    closeError: () => void;
}

export const useActionPlanSnackbars = (): IUseActionPlanSnackbarsResult => {
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarErrorMessage, setSnackbarErrorMessage] = useState("");

    const showSuccess = (message: string) => {
        setSnackbarMessage(message);
        setSnackbarErrorMessage("");
    };

    const showError = (message: string) => {
        setSnackbarErrorMessage(message);
        setSnackbarMessage("");
    };

    const closeSuccess = () => {
        setSnackbarMessage("");
    };

    const closeError = () => {
        setSnackbarErrorMessage("");
    };

    return {
        snackbarMessage,
        snackbarErrorMessage,
        showSuccess,
        showError,
        closeSuccess,
        closeError,
    };
};

